"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachMouseInput = exports.FakeTouchFinger = exports.attachKeyInput = void 0;
const Log_1 = __importDefault(require("../Log"));
const InputEmitter_1 = require("./InputEmitter");
const debounce_1 = require("debounce");
const CoordinateConverter_1 = require("./CoordinateConverter");
const MouseButtons_1 = require("./MouseButtons");
// Returns true if the given key is reserved for the browser
const isReservedKey = (reservedKeys, key) => {
    return reservedKeys.includes(key);
};
const attachKeyInput = (reservedKeys, emitter) => {
    // Prevent focus on buttons after clicking.
    document.addEventListener('click', () => {
        if (document.activeElement.toString() === '[object HTMLButtonElement]') {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }
    });
    document.onkeydown = (e) => {
        if (isReservedKey(reservedKeys, e.key)) {
            return;
        }
        if (emitter === null) {
            return;
        }
        emitter.EmitKeyDown(e);
        if (emitter.IsBrowserKey(e)) {
            e.preventDefault();
        }
    };
    document.onkeyup = (e) => {
        if (isReservedKey(reservedKeys, e.key)) {
            return;
        }
        if (emitter === null) {
            return;
        }
        emitter.EmitKeyUp(e);
        if (emitter.IsBrowserKey(e)) {
            e.preventDefault();
        }
    };
    document.onkeypress = (e) => {
        if (isReservedKey(reservedKeys, e.key)) {
            return;
        }
        if (emitter === null) {
            return;
        }
        emitter.EmitKeyPress(e.charCode);
    };
};
exports.attachKeyInput = attachKeyInput;
/**
 * The interface for finger position mapping
 */
class FakeTouchFinger {
    /**
     * @param id - the button id
     * @param x - the x axis value
     * @param y - the y axis value
     */
    constructor(id, x, y) {
        this.id = id;
        this.x = x;
        this.y = y;
    }
}
exports.FakeTouchFinger = FakeTouchFinger;
const attachMouseInput = (videoRef, emitter, useNativeTouchEvents = false, usePointerLock, pointerLockRelease) => {
    const coordinateConverter = new CoordinateConverter_1.CoordinateConverter(videoRef);
    let fakeTouchFinger;
    const fingers = [9, 8, 7, 6, 5, 4, 3, 2, 1, 0];
    const fingerIds = new Map();
    const maxByteValue = 255;
    let lastX = -1;
    let lastY = -1;
    let unlock = false;
    if (videoRef) {
        // Add 'touchstart' event listener
        videoRef.addEventListener('touchstart', function (event) {
            onTouchStart(event);
        });
        // Add 'touchend' event listener
        videoRef.addEventListener('touchend', function (event) {
            onTouchEnd(event);
        });
        // Add 'touchmove' event listener
        videoRef.addEventListener('touchmove', function (event) {
            onTouchMove(event);
        });
        videoRef.onmouseenter = (e) => {
            if (videoRef === null || emitter == null) {
                return;
            }
            emitter.EmitMouseEnter();
            e.preventDefault();
        };
        videoRef.onmouseleave = (e) => {
            if (videoRef === null || emitter == null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            /*
             * Handles when a mouse button is pressed down when the mouse leaves the videoRef. This will handle simultaneously pressed
             * Example: if the secondary (2) and auxilary (4) buttons are pressed simultaneously, the value is 6 (2 + 4).
             */
            if (e.buttons === InputEmitter_1.MouseButtonsState.PrimaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.MainButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.SecondaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.SecondaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.PrimarySecondaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.MainButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.SecondaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.AuxiliaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.AuxiliaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.PrimaryAuxilaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.MainButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.AuxiliaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.SecondaryAuxilaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.AuxiliaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.SecondaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.FourthButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.FourthButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.FifthButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            emitter.EmitMouseLeave();
            e.preventDefault();
        };
        videoRef.onmousedown = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            pointerLockDebounce(e);
            if (document.pointerLockElement === videoRef) {
                emitter.EmitMouseDown(e.button, lastX, lastY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else {
                emitter.EmitMouseDown(e.button, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
        };
        function setPointerLock(e) {
            if (!document.pointerLockElement && usePointerLock) {
                videoRef.requestPointerLock();
                lastX = e.x;
                lastY = e.y;
                unlock = true;
            }
            else {
                unlock = false;
            }
        }
        const pointerLockDebounce = (0, debounce_1.debounce)(setPointerLock, 200);
        videoRef.onmouseup = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            if (usePointerLock && pointerLockRelease) {
                pointerLockDebounce.clear();
            }
            if (document.pointerLockElement === videoRef && usePointerLock) {
                emitter.EmitMouseUp(e.button, lastX, lastY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else {
                emitter.EmitMouseUp(e.button, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            if (unlock && pointerLockRelease) {
                document.exitPointerLock();
            }
            e.preventDefault();
        };
        videoRef.onmousemove = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            if (document.pointerLockElement === videoRef && usePointerLock) {
                if (lastX < 0) {
                    lastX = viewPortWidth / 2;
                }
                if (lastY < 0) {
                    lastY = viewPortHeight / 2;
                }
                let x = lastX + e.movementX;
                let y = lastY + e.movementY;
                if (x > viewPortWidth) {
                    x -= viewPortWidth;
                }
                if (y > viewPortHeight) {
                    y -= viewPortHeight;
                }
                if (x < 0) {
                    x = x + viewPortWidth;
                }
                if (y < 0) {
                    y = viewPortHeight - y;
                }
                emitter.EmitMouseMove(x, y, e.movementX, e.movementY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                lastX = x;
                lastY = y;
            }
            else {
                emitter.EmitMouseMove(e.offsetX, e.offsetY, e.movementX, e.movementY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            e.preventDefault();
        };
        videoRef.oncontextmenu = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            e.preventDefault();
        };
        videoRef.onwheel = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            emitter.EmitMouseWheel(e.deltaY, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
        };
        /**
         * Remember a touch command
         * @param touch - the touch command
         */
        const rememberTouch = (touch) => {
            const finger = fingers.pop();
            if (finger === undefined) {
                Log_1.default.info('No fingers left to assign to touch');
            }
            fingerIds.set(touch.identifier, finger);
        };
        /**
         * Forgets a touch command
         * @param touch - the touch command
         */
        const forgetTouch = (touch) => {
            fingers.push(fingerIds.get(touch.identifier));
            // Sort array back into descending order. This means if finger '1' were to lift after finger '0', we would ensure that 0 will be the first index to pop
            fingers.sort(function (a, b) {
                return b - a;
            });
            fingerIds.delete(touch.identifier);
        };
        /**
         * When a touch event starts
         * @param touchEvent - the touch event being intercepted
         */
        const onTouchStart = (touchEvent) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            if (useNativeTouchEvents) {
                for (let t = 0; t < touchEvent.changedTouches.length; t++) {
                    rememberTouch(touchEvent.changedTouches[t]);
                }
                emitTouchData('TouchStart', touchEvent.changedTouches);
            }
            else {
                if (fakeTouchFinger == null) {
                    const first_touch = touchEvent.changedTouches[0];
                    fakeTouchFinger = new FakeTouchFinger(first_touch.identifier, first_touch.clientX - videoRef.clientLeft, first_touch.clientY - videoRef.clientTop);
                    const mouseEvent = new MouseEvent('mouseenter', first_touch);
                    videoRef.dispatchEvent(mouseEvent);
                    coordinateConverter.setupNormalizeAndQuantize();
                    const coord = coordinateConverter.normalizeAndQuantizeUnsigned(fakeTouchFinger.x, fakeTouchFinger.y);
                    emitter.sendMessageToStreamer('MouseDown', [MouseButtons_1.MouseEventButton.mainButton, coord.x, coord.y]);
                }
            }
            touchEvent.preventDefault();
        };
        /**
         * When a touch event ends
         * @param touchEvent - the touch event being intercepted
         */
        const onTouchEnd = (touchEvent) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            if (useNativeTouchEvents) {
                coordinateConverter.setupNormalizeAndQuantize();
                emitTouchData('TouchEnd', touchEvent.changedTouches);
                // Re-cycle unique identifiers previously assigned to each touch.
                for (let t = 0; t < touchEvent.changedTouches.length; t++) {
                    forgetTouch(touchEvent.changedTouches[t]);
                }
            }
            else {
                for (let t = 0; t < touchEvent.changedTouches.length; t++) {
                    const touch = touchEvent.changedTouches[t];
                    if (touch.identifier === (fakeTouchFinger === null || fakeTouchFinger === void 0 ? void 0 : fakeTouchFinger.id)) {
                        const x = touch.clientX - videoRef.clientLeft;
                        const y = touch.clientY - videoRef.clientTop;
                        coordinateConverter.setupNormalizeAndQuantize();
                        const coord = coordinateConverter.normalizeAndQuantizeUnsigned(x, y);
                        emitter.sendMessageToStreamer('MouseUp', [MouseButtons_1.MouseEventButton.mainButton, coord.x, coord.y]);
                        const mouseEvent = new MouseEvent('mouseleave', touch);
                        videoRef.dispatchEvent(mouseEvent);
                        fakeTouchFinger = null;
                        break;
                    }
                }
            }
            touchEvent.preventDefault();
        };
        /**
         * when a moving touch event occurs
         * @param touchEvent - the touch event being intercepted
         */
        const onTouchMove = (touchEvent) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            if (useNativeTouchEvents) {
                emitTouchData('TouchMove', touchEvent.touches);
            }
            else {
                for (let t = 0; t < touchEvent.touches.length; t++) {
                    const touch = touchEvent.touches[t];
                    if (touch.identifier === (fakeTouchFinger === null || fakeTouchFinger === void 0 ? void 0 : fakeTouchFinger.id)) {
                        const x = touch.clientX - videoRef.clientLeft;
                        const y = touch.clientY - videoRef.clientTop;
                        coordinateConverter.setupNormalizeAndQuantize();
                        const coord = coordinateConverter.normalizeAndQuantizeUnsigned(x, y);
                        const delta = coordinateConverter.normalizeAndQuantizeSigned(x - fakeTouchFinger.x, y - fakeTouchFinger.y);
                        emitter.sendMessageToStreamer('MouseMove', [coord.x, coord.y, delta.x, delta.y]);
                        fakeTouchFinger.x = x;
                        fakeTouchFinger.y = y;
                        break;
                    }
                }
            }
            touchEvent.preventDefault();
        };
        const emitTouchData = (type, touches) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            coordinateConverter.setupNormalizeAndQuantize();
            for (let t = 0; t < touches.length; t++) {
                const numTouches = 1; // the number of touches to be sent this message
                const touch = touches[t];
                const x = touch.clientX - videoRef.offsetLeft;
                const y = touch.clientY - videoRef.offsetTop;
                const coord = coordinateConverter.normalizeAndQuantizeUnsigned(x, y);
                switch (type) {
                    case 'TouchStart':
                        emitter.sendMessageToStreamer('TouchStart', [
                            numTouches,
                            coord.x,
                            coord.y,
                            fingerIds.get(touch.identifier),
                            maxByteValue * touch.force,
                            coord.inRange ? 1 : 0
                        ]);
                        break;
                    case 'TouchEnd':
                        emitter.sendMessageToStreamer('TouchEnd', [
                            numTouches,
                            coord.x,
                            coord.y,
                            fingerIds.get(touch.identifier),
                            maxByteValue * touch.force,
                            coord.inRange ? 1 : 0
                        ]);
                        break;
                    case 'TouchMove':
                        emitter.sendMessageToStreamer('TouchMove', [
                            numTouches,
                            coord.x,
                            coord.y,
                            fingerIds.get(touch.identifier),
                            maxByteValue * touch.force,
                            coord.inRange ? 1 : 0
                        ]);
                        break;
                }
            }
        };
    }
};
exports.attachMouseInput = attachMouseInput;
